import { LifeBuoy, HelpCircle, Mail, Flag, BookOpen, MessageCircleQuestion, Star } from 'lucide-react';
import SettingCard from '../../components/settings/SettingCard';
import SettingsRow from '../../components/settings/SettingsRow';

export default function Support() {
  return (
    <div className="space-y-6">
      <div className="hidden lg:block">
        <h1 className="text-2xl font-bold tracking-tight">Support</h1>
        <p className="text-sm text-neutral-500 dark:text-neutral-400">Get help or reach the Messego team</p>
      </div>

      <SettingCard>
        <div className="flex items-center gap-4">
          <div className="w-12 h-12 rounded-2xl bg-neutral-900 text-white flex items-center justify-center"><LifeBuoy className="w-6 h-6" /></div>
          <div>
            <h2 className="font-bold">We're here to help</h2>
            <p className="text-sm text-neutral-500 dark:text-neutral-400">Browse answers or contact us directly — most tickets get a reply within a day.</p>
          </div>
        </div>
      </SettingCard>

      <SettingCard title="Self-service" flush>
        <SettingsRow icon={HelpCircle} label="Help center" description="Search FAQs and guides" to="/app/settings/support/help" />
        <SettingsRow icon={BookOpen} label="Getting started guide" description="Learn the basics of Messego" to="/app/settings/support/help" />
      </SettingCard>

      <SettingCard title="Contact us" flush>
        <SettingsRow icon={Mail} label="Contact support" description="Send us a message" to="/app/settings/support/contact" />
        <SettingsRow icon={Flag} label="Report a problem" description="Bugs, abuse or payment issues" to="/app/settings/support/report" />
        <SettingsRow icon={MessageCircleQuestion} label="Community forum" description="Ask other Messego members" onClick={() => window.open('https://community.messego.com', '_blank', 'noreferrer')} />
      </SettingCard>

      <SettingCard title="Enjoying Messego?" flush>
        <SettingsRow icon={Star} label="Rate the app" description="Share your feedback with a review" onClick={() => window.open('https://messego.com', '_blank', 'noreferrer')} />
      </SettingCard>
    </div>
  );
}
